module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Bulb#2-30917f305966c6cab8b6302d36a6ccead68b92c031c04572f4091b03cea059d9.svg";